import { TFunction } from "i18next"



export const onRenderSeparator = (t: TFunction) => () => <div style={{ width: "90%", height: "12px", marginBottom: "20px", borderBottom: "1px solid rgba(0,0,0,.125)", textAlign: "center" }} className="container">
    <span style={{ fontSize: "1em", backgroundColor: "#fff", padding: "0 10px" }}>
        {t("Labels.OrLabel", "or")}
    </span>
</div>